import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageService } from '../services/page.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { NumPedidoModalComponent } from '../modal/num-pedido-modal/num-pedido-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-informe',
  templateUrl: './informe.component.html',
  styleUrls: ['./informe.component.css'],
})
export class InformeComponent implements OnInit, AfterContentChecked {
  datosVehiculos: FormGroup;
  datosColaborador: FormGroup;
  isEditable = true;
  formData: FormData;
  idSolicitud: string;

  constructor(
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private servicio: PageService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.inicio();
    this.numPedidoModal();
  }
  numPedidoModal(): void {
    const dialogRef2 = this.dialog.open(NumPedidoModalComponent, {
      width: '400px',

      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog',
    });
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get bastidorNoValido(): any {
    return (
      this.datosVehiculos.get('bastidor').invalid &&
      this.datosVehiculos.get('bastidor').touched
    );
  }

  get matriculaNoValido(): any {
    return (
      this.datosVehiculos.get('matricula').invalid &&
      this.datosVehiculos.get('matricula').touched
    );
  }

  get nif2NoValido(): any {
    return (
      this.datosColaborador.get('nif').invalid &&
      this.datosColaborador.get('nif').touched
    );
  }

  get denominacionNoValido(): any {
    return (
      this.datosColaborador.get('apellido1').invalid &&
      this.datosColaborador.get('apellido1').touched
    );
  }

  inicio(): void {
    this.idSolicitud = sessionStorage.getItem('id');
    sessionStorage.setItem('tipoCliente', '1');
    if (sessionStorage.getItem('colaborador') === 'null') {
      this.router.navigate(['page/home']);
    }
    this.crearFormulario();
    if (this.idSolicitud !== 'null') {
      console.log('aca');
      this.getSolicitud();
    } else {
      this.getColaborador(sessionStorage.getItem('colaborador'));
    }
  }

  crearFormulario(): any {
    this.datosColaborador = this.fb.group({
      tipo: '',
      colaborador: '',
      usuarioweb: '',
      nif: '',
      apellido1: '',
      sexo: '',
    });

    this.datosVehiculos = this.fb.group({
      bastidor: '',
      matricula: '',
    });
  }

  guardar(): void {
    if (
      this.datosVehiculos.controls['matricula'].value === '' &&
      this.datosVehiculos.controls['bastidor'].value === ''
    ) {
      Swal.fire('', 'Debe introducir uno de los dos campos');
    } else {
      const data = {
        ...this.datosColaborador.value,
        ...this.datosVehiculos.value,
      };
      data.numPedido = sessionStorage.getItem('numPedidoComun');
      data.colaborador = sessionStorage.getItem('colaborador');
      data.usuarioweb = sessionStorage.getItem('email');
      data.tipo = 'INFORME DE TRAFICO';
      data.docu = {};
      console.log(data);
      this.formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (data[key] !== null && data[key] !== undefined) {
          this.formData.append(key, data[key]);
        }
      });
      this.servicio.add_file(this.formData).subscribe(
        (res) => {
          console.log(res);
          Swal.fire('', 'Los datos se han guardado', 'success');
          this.router.navigate(['page/solicitudes']);
        },
        (error) => {
          console.log(error);
          if (error.status === 412) {
            Swal.fire('', error.error, 'warning');
            this.router.navigate(['page/solicitudes']);
          } else {
            Swal.fire('', error.error.message, 'warning');
          }
        }
      );
    }
  }

  getColaborador(colaborador): void {
    this.servicio.getColaborador(colaborador).subscribe((res) => {
      console.log(res);
      this.setDatos(res);
    });
  }

  setDatos(datos): void {
    this.datosColaborador.controls.nif.setValue(datos.nif);
    this.datosColaborador.controls.apellido1.setValue(datos.apellido1);
    //this.datosColaborador.controls.sexo.setValue(!datos.sexo ? 'EMPRESA' : datos.sexo);
    this.datosColaborador.controls.sexo.setValue('EMPRESA');
  }

  getSolicitud(): void {
    this.servicio.getOneSolicitud(this.idSolicitud).subscribe(
      (res) => {
        console.log(res);
        this.getColaborador(res.colaborador);
        this.setDato(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  setDato(datos): void {
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.matricula.setValue(datos.matricula);
  }
}
